import * as actionTypes from '../actions/ActionTypes'

export default function(state = [], action) {
  switch (action.type) {
    case actionTypes.LISTS_THEME_SMS:
      return action.listsThemeSMS
    default:
      return state
  }
}